import script from "./AppTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppTabs.vue?vue&type=script&lang=ts&setup=true"

import "./AppTabs.vue?vue&type=style&index=0&id=4d1b2897&lang=css"

const __exports__ = script;

export default __exports__